import GridCell from "../GridCell/GridCell";
import { ReactNode } from "react";

interface GridRowProps {
  children: ReactNode | ReactNode[];
}

const GridPresetWideContent = ({ children }: GridRowProps) => (
  <GridCell spanColsDesktop={3} spanColsTablet={6} spanColsMobile={6}>
    {children}
  </GridCell>
);

export default GridPresetWideContent;
